import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { FOLLOW_UP_FORM, FOLLOW_UP_DROPDOWN } from "./type";

export const getFollowUpDropDown = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.followUp.dropDown}?lead_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FOLLOW_UP_DROPDOWN, payload: data.response.data });
    return true;
  }
};

export const saveFollowUp = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.followUp.saveForm
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FOLLOW_UP_FORM, payload: data.response.data });
    return true;
  }
};
